import React from 'react'
import { confirmationEmailPage } from './confirmationEmailPage'
import { ConfirmationEmail } from '../components/ConfirmationEmail'
import { PrintFOIA } from '../components/PrintFOIA'
import { Submit } from '../components/Submit'

export const reviewFugitivePage = complaintInspect => {
  const confirmEmailPage = confirmationEmailPage({}, 'email')
  return {
    id: 'review_page',
    fields: [
      {
        type: 'content',
        content: PrintFOIA
      },
      {
        type: 'content',
        content: complaintInspect
      },
      {
        type: 'content',
        content: () => (
          <ConfirmationEmail
            title="Email receipt of tip submission"
            message="Do you wish to receive an email of receipt of this tip submission? This receipt does NOT include your responses."
          />
        )
      },
      ...confirmEmailPage.fields,
      {
        type: 'content',
        content: () => (
          <Submit
            title="Now submit your tip"
            text="By submitting this tip, you are confirming that the details you are providing are true to the best of your knowledge."
          />
        )
      }
    ],
    validation: confirmEmailPage.validation
  }
}
